import ExcludedVehicles from './ExcludedVehicles';

export default ExcludedVehicles;
